export default {
  setPlans(state, plans) {
    state.plans = plans;
  },
  setPlan(state, plan) {
    state.plan = plan;
  },
  setPagination(state, pagination) {
    state.pagination = pagination;
  }
};
